import axios from "axios";

const defaultURL = "http://127.0.0.1:5177";
const storageKey = "rdworks_agent_url";

// --- 1. Функции-утилиты

export const GetRdworksAgentURL = () => {
  let url = localStorage.getItem(storageKey);
  if (!url) {
    SetRdworksAgentURL(defaultURL);
    url = defaultURL;
  }
  return url;
};

export const SetRdworksAgentURL = (url) => {
  if (url) {
    localStorage.setItem(storageKey, url);
  }
};

export const ResetRdworksAgentURL = () => {
  localStorage.removeItem(storageKey);
};

export const getHealthUrl = () => {
  return GetRdworksAgentURL() + "/api/health";
};

export const getOpenUrl = () => {
  return GetRdworksAgentURL() + "/api/open";
};

// --- 2. Axios-инстанс

const rdworksAgentService = axios.create({
  baseURL: GetRdworksAgentURL() + "/api",
  timeout: 5 * 60 * 1000, // скачивание + запуск RDWorks может занять время
});

// --- 3. Навешиваем утилиты на инстанс

rdworksAgentService.GetRdworksAgentURL = GetRdworksAgentURL;
rdworksAgentService.SetRdworksAgentURL = SetRdworksAgentURL;
rdworksAgentService.ResetRdworksAgentURL = ResetRdworksAgentURL;
rdworksAgentService.getHealthUrl = getHealthUrl;
rdworksAgentService.getOpenUrl = getOpenUrl;

// --- 4. Методы

/**
 * Проверка, что локальный агент запущен и RDWorks доступен.
 * @returns {Promise<{status: string, rdworksAvailable: boolean}>}
 */
rdworksAgentService.health = async () => {
  const res = await rdworksAgentService.get(getHealthUrl());
  return res.data;
};

/**
 * Отправить задание на открытие в RDWorks.
 * Bearer-токен берётся из localStorage и добавляется интерцептором.
 * @param {string|number} sheetId
 * @returns {Promise<{opened: boolean, filePath: string}>}
 */
rdworksAgentService.openSheet = async (sheetId) => {
  const res = await rdworksAgentService.post("/open", { sheetId: String(sheetId) });
  return res.data;
};

// --- 5. Interceptor: пробрасываем Bearer-токен бэкенда в агент,
//     чтобы агент мог сам скачать файл.

rdworksAgentService.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("access_token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// --- 6. Interceptor ответов: аккуратно обрабатываем сетевые ошибки агента.
//     ВАЖНО: 401 здесь означает, что токен невалиден на бэкенде,
//     а не то, что пользователь не авторизован в основном приложении,
//     поэтому НЕ выкидываем его на /login, а просто отклоняем промис.

rdworksAgentService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      // Агент не запущен / недоступен / CORS
      error.isAgentUnavailable = true;
    }
    return Promise.reject(error);
  }
);

export default rdworksAgentService;